import { Typography } from "@mui/material";
import { NumericFormat } from "react-number-format";
import { NoData } from "./NoData";
import { CommonFieldProps } from "./types";

type NumericFieldProps = CommonFieldProps & { decimalScale?: number };

export const NumericField = ({
  name,
  data,
  getValue,
  decimalScale = 2,
}: NumericFieldProps) => {
  const value = getValue ? getValue(data) : data[name];

  return value ? (
    <Typography>
      <NumericFormat
        valueIsNumericString
        thousandSeparator="."
        decimalSeparator=","
        allowNegative
        value={value.toFixed(decimalScale).toString()}
        displayType="text"
      />
    </Typography>
  ) : (
    <NoData />
  );
};
